import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appUrlNormalizer]'
})
export class UrlNormalizerDirective {

  constructor() { }
// Inject the control bound to this specific input
  private readonly ngControl = inject(NgControl);

  @HostListener('blur')
  onBlur() {
    const control = this.ngControl.control;
    const value = control?.value?.trim();

    if (control?.valid && value) {
      try {
        let normalized = value;
        if (!/^https?:\/\//i.test(normalized)) 
          normalized = 'https://' + normalized;
        
        const urlObj = new URL(normalized);
        // Update the form value directly
        control.setValue(urlObj.href, { emitEvent: false });
      } catch {
        // Ignore if invalid
      }
    }
  }
}
